<template>
  <el-dialog :title="dialogTitle" :visible.sync="editContentFormVisible">
    <el-form
      :model="contentForm"
      :rules="rules"
      ref="contentForm"
      label-width="100px"
      class="demo-dynamic"
    >
      <el-form-item label="工作内容" prop="tips">
        <el-input v-model="contentForm.tips"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="imgPaths">
        <el-upload
          ref="imgUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :limit="6"
          :data = "uploadData"
          :on-exceed="uploadImgExceed"
          :on-success="imgPathsSuccess"
          :on-remove="imgPahthRemove"
          :before-upload="uploadImgBefore"
          :file-list="imgList"
          list-type="picture-card"
          multiple
        >
          <i v-if="imgList.length<2" class="el-icon-plus avatar-uploader-icon" ></i>
          <div slot="tip" class="el-upload__tip">支持jpg,jpeg,bmp,gif,png格式照片，大小不超过5M，最多上传9张图片</div>
        </el-upload>
      </el-form-item>
      <el-form-item label="视频" prop="voicePaths">
        <el-upload
          ref="voiceUpload"
          :action="'/files/fileUpload'|getBaseApiUrl"
          :on-success="voicePathsSuccess"
          :before-upload="uploadVoiceBefore"
          :show-file-list="false"
          :data = "uploadData"
          list-type="picture-card"
        >
          <video style="float:left;" width="278px" v-if="voicePath" :src="voicePath|getBaseImgUrl" controls="controls">您的浏览器不支持视频播放</video>

          <i class="el-icon-plus" v-else></i>
          <div slot="tip" class="el-upload__tip">支持mp4,avi格式视频，大小不超过100M，最多上传1个视频</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer" style="text-align:center">
      <el-button type="primary" @click="save(1)">保存</el-button>
      <el-button type="primary" @click="save(2)">继续添加</el-button>
      <el-button @click="close">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { companytable } from "@/const/asset/user";
import { objKeySort } from "@/util/ajaxsign";
import { apiLink, getImgLink } from "@/config/env";
export default {
  name: "editContent",
  data() {
    return {
      editContentFormVisible: false,
      dialogTitle: "添加工作内容",
      uploadData:{},
      contentForm: {
        id: "",
        tips: "",
        imgPaths: "",
        imgCount:0,
        voicePaths: "",
        voiceCount:0
      },
      imgList:[],
      voicePath:'',
      rules: {
        tips: [{ required: true, message: "请填写工作内容", trigger: "blur" }]
      }
    };
  },
  created() {
    this.uploadData = objKeySort({});
    console.log(this.uploadData);
  },
  filters: {
    dataFormat: function(dateStr) {
      return dateY(dateStr);
    },
    getBaseApiUrl: function(uri) {
      if (uri) {
        return apiLink(uri);
      } else {
        return "";
      }
    },
    getBaseImgUrl: function(uri) {
      console.log(uri);
      if (uri) {
        return getImgLink(uri);
      } else {
        return "";
      }
    }
  },
  methods: {
    uploadImgBefore(file) {
      let isImg = false;
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/bmp" ||
        file.type == "image/jpg" ||
        file.type == "image/gif"
      ) {
        isImg = true;
      }
      const isLt8M = file.size / 1024 / 1024 < 8;
      if (!isImg) {
        this.$message.error("上传图片只能是jpg,jpeg,bmp,gif,png格式照片!");
      }
      if (!isLt8M) {
        this.$message.error("上传图片大小不能超过 8MB!");
      }
      return isImg && isLt8M;
    },
    uploadVoiceBefore(file) {
      let isVoice = false;
      if (
        file.type == "video/mp4" ||
        file.type == "video/avi"
      ) {
        isVoice = true;
      }
      const isLt100M = file.size / 1024 / 1024 < 100;
      if (!isVoice) {
        this.$message.error("上传视频只能是MP4,AVI格式视频文件!");
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小不能超过 100MB!");
      }
      return isVoice && isLt100M;
    },
    imgPahthRemove(file,fileList){
      this.contentForm.imgPaths = "";
      this.contentForm.imgCount = 0;
      if(fileList&&fileList.length>0){
        fileList.forEach(f => {
          if (f.response&&f.response.data.filePath) {
            this.contentForm.imgCount = this.contentForm.imgCount + 1;
            if (this.contentForm.imgPaths) {
              this.contentForm.imgPaths = this.contentForm.imgPaths + ",";
            }
            this.contentForm.imgPaths =
              this.contentForm.imgPaths + f.response.data.filePath;
            this.imgList.push({url:getImgLink(f.response.data.filePath)});
          }
        });
      }
      console.log(fileList,this.contentForm);
    },
    //文件变化
    imgPathsSuccess(res) {
      debugger
        if(res.data&&res.data.filePath){
          if (this.contentForm.imgPaths) {
              this.contentForm.imgPaths = this.contentForm.imgPaths + ",";
          }
          this.imgList.push({url:getImgLink(res.data.filePath)});
          this.contentForm.imgCount++;
        }
      // if(fileList&&fileList.length>0){
      //   this.contentForm.imgPaths = "";
      //   this.contentForm.imgCount = 0;
      //   fileList.forEach(f => {
      //     if (f.response&&f.response.data.filePath) {
      //       this.contentForm.imgCount = this.contentForm.imgCount + 1;
      //       if (this.contentForm.imgPaths) {
      //         this.contentForm.imgPaths = this.contentForm.imgPaths + ",";
      //       }
      //       this.contentForm.imgPaths =
      //         this.contentForm.imgPaths + f.response.data.filePath;
      //       this.imgList.push({url:getImgLink(f.response.data.filePath)});
      //     }
      //   });
      // }
      // console.log(fileList,this.contentForm);
    },
    //文件变化
    voicePathsSuccess(res) {
        this.contentForm.voicePaths = "";
        this.contentForm.voiceCount = 0;
        this.voicePath = '';
        if(res.data&&res.data.filePath){
          this.voicePath = res.data.filePath;
          this.contentForm.voicePaths = res.data.filePath;
          this.contentForm.voiceCount = 1;
        }


        // fileList.forEach(f => {
        //   if (f.response&&f.response.data.filePath) {
        //     this.contentForm.voiceCount = this.contentForm.voiceCount+1;
        //     if (this.contentForm.voicePaths) {
        //       this.contentForm.voicePaths = this.contentForm.voicePaths + ",";

        //     }
        //     this.contentForm.voicePaths =
        //       this.contentForm.voicePaths + f.response.data.filePath;
        //       this.voiceList.push({url:f.response.data.filePath});
        //   }
        // });
      // }
    },
    uploadImgExceed(files, fileList) {
      this.$message.warning(
        `照片最多只能上传6张`
      );
    },
    uploadVoiceExceed(files, fileList) {
      this.$message.warning(
        `视频最多只能上传3个`
      );
    },
    setData(data) {
      this.editContentFormVisible = true;
      if (data) {
        this.contentForm = data;
        this.dialogTitle = "修改工作内容";
        if(data.imgPaths){
          data.imgPaths.split(",").forEach(path => {
            this.imgList.push({url:getImgLink(path)})
          })
        }
        if(data.voicePaths){
          data.voicePaths.split(",").forEach(path => {
            this.voiceList.push({url:getImgLink(path)})
          })
        }
      } else {
        this.dialogTitle = "添加工作内容";
        this.cleanForm();
      }
    },
    save(type) {
      console.log(this.$refs.imgUpload.fileList);
      this.$emit("setContent", this.contentForm);
      if (type == 1) {
        this.close();
      } else {
        this.cleanForm();
      }
    },
    close() {
      this.editContentFormVisible = false;
    },
    cleanForm() {
      this.$refs.contentForm.resetFields();
      this.$refs.imgUpload.clearFiles();
      this.$refs.voiceUpload.clearFiles();
      this.imgList=[];
      this.voicePath = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
